import { lazy } from 'react';

// project imports
import Loadable from 'ui-components/loadhandlers/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const Onboarding = Loadable(lazy(() => import('views/onboarding')));
const PreviewFeaturedTripGuide = Loadable(lazy(() => import('views/trip-guide/PublicTripGuideMainUI')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const OnboardingRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/onboarding',
      element: <Onboarding />
    },
    {
      path: '/influencer/onboarding',
      element: <Onboarding />
    },
    {
      path: '/creator/onboarding',
      element: <Onboarding />
    },
    {
      // Canonical public guide URL. One segment after /guides/, which keeps the
      // Phase 2 destination hubs at /guides/destinations/<name> from colliding.
      path: '/guides/:slugId',
      element: <PreviewFeaturedTripGuide />
    },
    {
      // Legacy. The Express layer 301s this to the canonical path, but the route
      // stays so links already shared keep rendering if the redirect is ever
      // disabled, and so local dev without the Express server still works.
      path: '/featured-trip-guide',
      element: <PreviewFeaturedTripGuide />
    }
  ]
};

export default OnboardingRoutes;
